import { Svg } from 'components/svg'
import { FC, SVGAttributes } from 'react'

export const IconClose: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <Svg {...props} viewBox="-5 -5 30 30">
    <path
      d="M2 1.58578L23.3345 22.9203"
      stroke="currentColor"
      strokeWidth="3"
    />
    <path
      d="M23.707 1.70712L2.41414 23"
      stroke="currentColor"
      strokeWidth="3"
    />
  </Svg>
)
